/**
    These are global constants that you can import on to partials
*/
export const GLOBAL_BODY = document.getElementsByTagName('body')[0];
export const GLOBAL_HTML = document.getElementsByTagName('html')[0];
export const UTILITY_NAV = document.getElementById('utilityNav');
export const HEADER = document.getElementById('mHeader');
export const MOD_NO_TOUCH_EVENTS = 'mod-no-touchevents';
export const MOD_TOUCH_EVENTS = 'mod-touchevents';



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/constants.ts